<!-- 单点登录页 -->
<template>
  <div class="common-wrap">
    <h1 class="logo">
      <img :src="logoImg" />
    </h1>
    <div class="intro">
      <div>灵活用工数字化共享经济服务平台</div>
    </div>
    <div class="login-box">
      <div class="box-title">欢迎登录</div>
      <el-form
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
        class="login-input-wrapper"
      >
        <el-form-item label="账号类型:">
          <el-radio-group v-model="loginForm.bid">
            <el-radio
              v-for="item in accountTypeOptions"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item class="icon-input" prop="account">
          <icon name="el-icon-user" class="login-input-icon" />
          <el-input
            v-model="loginForm.account"
            placeholder="请输入手机号/企业账号"
          >
          </el-input>
        </el-form-item>
        <el-form-item class="icon-input" prop="password">
          <icon name="el-icon-lock" class="login-input-icon" />
          <el-input
            v-model="loginForm.password"
            placeholder="请输入密码"
            show-password
            @keyup.enter.native="onSubmit"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="captchaCode">
          <div class="captcha-wrapper">
            <el-input
              v-model="loginForm.captchaCode"
              placeholder="请输入验证码"
              @keyup.enter.native="onSubmit"
            >
            </el-input>
            <img
              :src="captchaImg"
              @click="getCaptcha"
              class="captcha-img"
              title="点击刷新验证码"
            />
          </div>
        </el-form-item>
      </el-form>
      <div class="login-box-bottom">
        <el-button type="primary" @click="onSubmit" :loading="loading"
          >立即登录</el-button
        >
        <div>
          <div>
            没有账号？<span class="primary-color text-btn" @click="onRegister"
              >新用户注册</span
            >
          </div>
          <div class="primary-color text-btn" @click="onResetPassword">
            忘记密码？
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ACCOUNT_TYPE, accountTypeOptions } from "@/common/config";
import { login, code } from "@/api";
import { setData } from "@/common/auth";
import { getBid } from "@/utils/auth";
import { ssoService, SSO_CONFIG } from "@/plugins/ajx-common";

export default {
  data() {
    return {
      ACCOUNT_TYPE: Object.freeze(ACCOUNT_TYPE),
      accountTypeOptions: Object.freeze(accountTypeOptions),
      loading: false,
      logoImg: require("@/assets/img/img_logo@2x.png"),
      loginForm: {
        bid: ACCOUNT_TYPE.ENT,
        account: "",
        password: "",
        captchaCode: "",
        captchaUuid: "",
      },
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        captchaCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      captchaImg: "",
    };
  },
  mounted() {
    // 页面加载时获取验证码
    this.getCaptcha();
  },
  methods: {
    // 获取验证码
    getCaptcha() {
      code()
        .then((res) => {
          this.captchaImg = res.img;
          this.loginForm.captchaUuid = res.uuid;
        })
        .catch((err) => {
          console.error("获取验证码失败:", err);
          this.$message.error("获取验证码失败");
        });
    },
    // 登录
    onSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          console.log("this.loginForm----", this.loginForm);
          // 1. 登录
          login(
            this.loginForm.bid,
            this.loginForm.account,
            this.loginForm.password,
            this.loginForm.captchaUuid,
            this.loginForm.captchaCode
          )
            .then((res) => {
              console.log("res----", res);
              // 2. setToken和setTenantId、bid
              setData(res.accessToken, res.tenantId, res.bid);
              // 3. 跳转
              const query = this.$route.query;
              console.log("query----", query);
              // 获取当前用户的bid
              const userBid = getBid();
              const redirectMap = {
                1: SSO_CONFIG.FrontProject.CUSTOMER_SYSTEM,
                2: SSO_CONFIG.FrontProject.ENT,
              };
              // 判断是否有来源页且来源页合法
              if (
                query.redirect &&
                query.project &&
                (redirectMap[userBid] === query.project ||
                  SSO_CONFIG.FrontProject.PORTAL === query.project)
              ) {
                console.log("query.redirect----", query.redirect);
                console.log("来源页跟bid对应");
                // 来源页跟bid对应，跳转到来源页
                ssoService.redirect(query.project, {
                  replace: true,
                  redirect: query.redirect,
                });
              } else {
                console.log("没有来源页跳转到对应端的首页");
                const targetProjectName =
                  redirectMap[userBid] || SSO_CONFIG.FrontProject.PORTAL;
                // 没有来源页或来源页跟bid不对应跳转到门户首页，
                ssoService.redirect(targetProjectName, {
                  replace: true,
                  redirect: "#/",
                  // 是否拼接域名
                  needDomain: true,
                });
              }
            })
            .catch((err) => {
              // 登录失败时自动刷新验证码
              this.getCaptcha();
              // 清空验证码输入
              this.loginForm.captchaCode = "";
              console.log(err);
            });
          setTimeout(() => {
            this.loading = false;
          }, 200);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 注册
    onRegister() {
      console.log("跳转到注册中间页");
      this.$router.push({
        name: "RegisterIntermediatePage",
      });
    },
    // 忘记密码
    onResetPassword() {
      console.log("跳转到忘记密码页面");
      this.$router.push({
        name: "ResetPassword",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.common-wrap {
  min-height: 100vh;
  background-image: url("@/assets/img/bg_img01@2x.png");
  .intro {
    position: absolute;
    top: 228px;
    left: 204px;
    div {
      font-size: 40px;
      font-weight: 400;
      color: #333333;
      line-height: 47px;
      margin-bottom: 16px;
    }
    span {
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      line-height: 19px;
      margin-right: 32px;
    }
  }
  .login-box {
    width: 488px;
    height: 498px;
    position: absolute;
    top: 50%;
    right: 268px;
    background: #ffffff;
    border-radius: 16px;
    padding: 64px 56px;
    box-sizing: border-box;
    transform: translateY(-50%);
    .box-title {
      width: 80px;
      height: 32px;
      font-size: 20px;
      font-weight: bold;
      color: #f66717;
      line-height: 23px;
      border-bottom: 4px solid #f66717;
    }
    .login-input-wrapper {
      margin: 56px 0 20px 0;
      .icon-input {
        position: relative;
        &:last-of-type {
          margin-top: 16px;
        }
        .login-input-icon {
          position: absolute;
          top: 14px;
          left: 8px;
          z-index: 22;
        }
        ::v-deep .el-input__inner {
          padding: 0 32px;
        }
      }
      .captcha-wrapper {
        display: flex;
        align-items: center;
        gap: 12px;

        .el-input {
          flex: 1;
        }

        .captcha-img {
          width: 106px;
          height: 40px;
          cursor: pointer;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          object-fit: cover;

          &:hover {
            border-color: #f66717;
          }
        }
      }
    }
    .login-box-bottom {
      .el-button {
        width: 100%;
        margin-bottom: 24px;
      }
      div {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #757474;
        .text-btn {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
